<div class="service-metric-tile little-box-shadow" [style.border-top-color]="topBorderColor">
    <loader [size]="'medium'" *ngIf="loader"></loader>
    <div [id]='id + "service-metric-line-chart"' *ngIf="!loader">
        <div style="width:95%; margin:auto; position:relative;">
            <h3 class='line-chart'>{{ hasFindingsMetrics(title) ? (title | capitalize) : title }}</h3>
            <div class="call-metrics-wrapper">
                <h2 class='line-chart-number'>{{this.totalCount | number:'1.00':'en-US'}}</h2>
                <div class="growth-block" *ngIf="growthDateRangeAvailable">
                  <div class="gray-line"></div>
                  <span *ngIf="division == Division.Pest" class="comparison-type-indicator text-base">YoY Change:&nbsp;</span>
                    <ng-container *ngIf="growth != null; else noGrowth">
                        <span class="arrow flex items-center">
                            <img src="/assets/shared-icons/neptune-icon-blue-solid-chevron-down.svg" alt="growth-arrow-icon" class="flex self-center" [ngClass]="this.growthPositive ? 'rotate-180' : ''"/>
                        </span>
                        <span class="growth-value">
                        {{ this.growth | number:'1.0-0':'en-US'}}%
                        </span>
                    </ng-container>
                    <ng-template #noGrowth>
                    <span class="text-base text-blue">N/A</span>
                    </ng-template>
                </div>
            </div>
        </div>

        <div class="checkbox-container" *ngIf="isEnableCheckBox">
            <input id="line-chart-checkbox" #addServiceMetric type="checkbox" [checked]="checked" (click)="$event.stopPropagation()" (change)="_onCheckedChange(addServiceMetric.checked)"> Add
        </div>

        <div class="chart-container">
            <div echarts class="chart" [options]="chartOptions"></div>
        </div>
    </div>
</div>
